'use strict';

var AdvancedHepGridDuplicateRowButtonDirective = function AdvancedHepGridDuplicateRowButtonDirective() {
  return {
    restrict: 'E',
    require: '^^rmGridToolbar',
    scope: true,
    template: require('../templates/advanced-hep-grid-duplicate-row-button.html'),
    controller: 'AdvancedHepGridDuplicateRowButtonController',
    link: function link($scope) {
      $scope.$on('grid:rowSelectionChanged', function (event, selectedRows, gridId, allRows, selectedRowIndexes) {
        $scope.onRowSelection(selectedRows, selectedRowIndexes);
      });
    }
  };
};
AdvancedHepGridDuplicateRowButtonDirective.$inject = [];
module.exports = AdvancedHepGridDuplicateRowButtonDirective;